<template lang="html">
<div class="content-block">
  <nav>
    <router-link class="nav-link nav-link--normal" to="/">Merten Hanisch</router-link> <span class="hide-mobile">| </span>
    <ul>
      <li v-if="!page.hideFromMenu" v-for="page in pages">
        <router-link class="nav-link" :to="page.path" exact>{{page.name}}</router-link>
        <span>|&nbsp;</span>
      </li>
    </ul>
  </nav>
</div>
</template>

<style scoped>
  .nav-link {
    display: inline-block;
    padding: .5rem 0;
  }
  .nav-link--active {
    color: var(--color-yellow)
  }
  .nav-link--normal {
    color: inherit;
    display: block;
  }
  nav ul {
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  nav li {
    display: inline-block;
  }
  nav li:last-child span {
    display: none;
  }
  .hide-mobile {
    display: none;
  }

  @media screen and (min-width: 1024px) {
    .nav-link {
      padding: 0;
    }
    .nav-link--normal {
      display: inline-block;
    }

    .hide-mobile {
      display: inline-block;
    }
  }

</style>

<script>
  import Router from '../../router/index'
  export default {
    name: 'navmain',
    data () {
      return {
        pages: Router.options.routes
      }
    }
  }
</script>



// WEBPACK FOOTER //
// navmain.vue?45762078